import {
  Component,
  effect,
  Injector,
  OnInit,
  signal,
  ViewChild,
  WritableSignal
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatMenuTrigger, MatMenuModule} from '@angular/material/menu';
import {MatSelectChange} from '@angular/material/select';
import {TranslateModule} from '@ngx-translate/core';
import {NgForOf, NgIf, NgStyle} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {FeedbackConfig, FeedbackMode} from '@q9elements/ui-kit/common';
import {IconButtonComponent, FeedbackModule, SelectModule} from '@q9elements/ui-kit/components';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {feedbackSelectOptions} from './models/constants';
import {RequestsService} from '../../../core/requests/requests.service';
import {map} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-diagram-comments',
  templateUrl: './diagram-comments.component.html',
  styleUrls: ['./diagram-comments.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatBadgeModule,
    MatTooltipModule,
    MatIconModule,
    NgIf,
    NgStyle,
    TranslateModule,
    IconButtonComponent,
    FeedbackModule,
    SelectModule,
    FormsModule,
    NgForOf
  ]
})
export class DiagramCommentsComponent implements OnInit {
  readonly feedbackConfig: WritableSignal<Partial<FeedbackConfig> | null> = signal(null);
  readonly selectedMode = signal(FeedbackMode.opened);
  readonly selectOptions = feedbackSelectOptions;
  readonly diagramId = toSignal(this.diagramJsonSvc.diagramJson$.pipe(map(json => json.diagramId)));

  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;
  usersCount = 0;
  commentsCount = 0;

  constructor(
    private diagramJsonSvc: DiagramJsonHandlerService,
    private requestsSvc: RequestsService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.getCommentsOnInit();
    this.setFeedbackConfig();
  }

  public changeState(mode: MatSelectChange) {
    this.selectedMode.set(mode.value);
  }

  private setFeedbackConfig(): void {
    effect(
      () => {
        this.feedbackConfig.update(config => ({
          ...config,
          ownerType: 'Diagram',
          ownerId: this.diagramId(),
          perPage: 999,
          ownerTitle: 'ownerTitle',
          page: 1,
          mode: this.selectedMode()
        }));
      },
      {allowSignalWrites: true, injector: this.injector}
    );
  }

  private getCommentsOnInit() {
    effect(
      () => {
        this.requestsSvc
          .addToQueue(
            {
              isApi: true,
              method: 'GET',
              url: `/comment`,
              queryParams: {
                mode: 'opened',
                perPage: '999',
                ownerId: this.diagramId(),
                ownerType: 'Diagram',
                page: 1
              }
            },
            true
          )
          .then(comments => {
            this.commentsCount = 0;
            comments.forEach(
              comment => (this.commentsCount += this.getRepliesCount(comment.replies))
            );
            this.commentsCount += comments.length;
          });
      },
      {allowSignalWrites: true, injector: this.injector}
    );
  }

  getRepliesCount(replies): number {
    const repliesUsersMessages = replies.filter(replie => replie.status === 1);

    return repliesUsersMessages.length;
  }
}
